import React from 'react';
import './index.css';

const DescriptionItem = ({title, description, mapValues, className}) => {
    return (
        <div className={`description-item ${className ? className : ''}`}>
            <p className="title">{title}</p>
            {description && <p className="description">{description}</p> }
            {mapValues && mapValues.map((obj, idx) => 
                <div key={idx}>
                    <span className="key">{obj.key}</span>
                    <span>{obj.value}</span>
                </div>)}
        </div>
    );
}

export default  DescriptionItem;